import * as React from "react";
import { HudButtonOffers } from "../../generic/hud-button-offers/HudButtonOffers";
export var BF2HudRightTop = function () { return React.createElement(HudButtonOffers, null); };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/hud/BF2HudRightTop.tsx
// module id = 2297
// module chunks = 3